import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AUTH_CALLBACK_ROUTE, LOGIN_ROUTE } from '../routes'
import { isJwtExpired } from '../utils/jwtExpiry'
import { jwtStorage } from '../utils/jwtStorage'
import { saveReturnTo } from '../utils/returnTo'

const useAuthenticate = (): void => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    // The callback owns the token exchange; the login page has no token by design
    if (
      pathname === AUTH_CALLBACK_ROUTE.route ||
      pathname === LOGIN_ROUTE.route
    ) {
      return
    }
    if (isJwtExpired(jwtStorage.get())) {
      jwtStorage.remove()
      saveReturnTo()
      navigate(LOGIN_ROUTE.route)
    }
  }, [navigate, pathname])
}

export default useAuthenticate
